<template>
    <div class="login-page">
        <div class="layer bg" id="login"></div>
        <div class="layer flex-center">
            <!-- logo部分 -->
            <div class="logo-group">
                <!--<img src="./image/logo-sc.png" alt="logo">-->
                <span class="login-title">{{loginTitle}}</span>
            </div>
            <!-- 表单部分 -->
            <div class="form-group">
                <el-card>
                    <el-form ref="loginForm" label-position="top" :model="formLogin" :rules="rules" :show-message="false" :status-icon="true">
                        <el-form-item prop="account">
                            <el-input type="text" v-model="formLogin.account" placeholder="用户名">
                                <i slot="prepend" class="fa fa-envelope-o"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input type="password" v-model="formLogin.password" placeholder="密码"
                                      @keyup.enter.native="submit">
                                <i slot="prepend" class="fa fa-lock"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item v-if="isShowCode" prop="code">
                            <el-input type="text" v-model="formLogin.code" placeholder="验证码"
                                      @keyup.enter.native="submit">
                                <template slot="prepend">
                                    <i class="fa fa-shield"></i>
                                </template>
                                <template slot="append">
                                    <img class="login-code" :src="loginCodeUrl" @click="changeLoginCode"
                                         style="cursor: pointer">
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-button @click="submit" type="primary" class="button-login" :loading="disabledSubmit">登录
                        </el-button>
                        <!--<div style="float: right;">
                          <el-button type="text">注册用户</el-button>
                        </div>-->
                    </el-form>
                </el-card>
            </div>
            <!-- 快速登陆按钮 -->
            <!--el-button type="info" class="button-help" @click="dialogVisible = true">
                快速选择用户（演示用户快捷登录）
            </el-button-->
        </div>
        <el-dialog
                title="快速选择用户"
                :visible.sync="dialogVisible"
                width="400px">
            <el-row :gutter="10" style="margin: -20px 0px -10px 0px;">
                <el-col v-for="(user, index) in users" :key="index" :span="8">
                    <div class="user-btn" @click="handleUserBtnClick(user)">
                        <d2-icon name="user-circle-o"/>
                        <span>{{user.name}}</span>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
    /* eslint-disable */
    require('particles.js')
    import config from './config/default'
    import {mapActions} from 'vuex'
    import RSAUtils from '@/libs/security.js'
    import util from '@/libs/util.js'
    import { getMenuHeader } from '@/menu'
    import { formatMenuData } from '@/libs/menuUtils.js'

    // 邮箱格式校验函数
    const validateEmail = (rule, value, callback) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!value) {
            callback(new Error('邮箱不能为空'))
        } else if (!emailRegex.test(value)) {
            callback(new Error('请输入正确的邮箱地址'))
        } else {
            callback()
        }
    }

    export default {
        data() {
            return {
                // 快速选择用户
                dialogVisible: false,
                // 是否显示验证码
                isShowCode: false,
                loginCodeUrl: '', //登录验证码地址
                disabledSubmit: false, // 禁用登陆按钮
                loginTitle: process.env.VUE_APP_TITLE,
                // 表单
                users:'',
                formLogin: {
                    // account: 'admin@lthpc.com',
                    // password: 'vuJdVxc6PB',
                    account: '',
                    password: '',
                    code: ''
                },
                // 校验
                rules: {
                    // account: [
                    //     { required: true, message: '请输入', trigger: 'blur' },
                    //     { validator: validateEmail, trigger: 'blur' } // 可以自定义邮箱格式校验
                    // ],
                    account: [
                        {required: true, message: '请输入用户名', trigger: 'change'}
                    ],
                    password: [
                        {required: true, message: '请输入密码', trigger: 'change'}
                    ],
                    code: [
                        {required: false, message: '请输入验证码', trigger: 'change'}
                    ]
                    
                }
            }
        },
        mounted() {
            // 初始化例子插件
            particlesJS('login', config)
            //初始化是否显示验证码区
            // this.initIsShowCode()
        },
        methods: {
            ...mapActions([
                'd2adminLogin'
            ]),
            /**
             * @description 接收选择一个用户快速登陆的事件
             * @param {Object} user 用户信息
             */
            handleUserBtnClick(user) {
                this.formLogin.account = user.account
                this.formLogin.password = user.password
                this.submit()
            },
            /**
             * @description 提交表单
             */

            formatMenuData(data) {
                const defaultIcon = 'folder-o';
                const result = [];

                function traverse(list) {
                    if (!list || !Array.isArray(list)) return;
                    list.forEach(item => {
                        if (item.type === 1) {
                            // 处理目录类型，作为父菜单
                            const menuItem = {
                                path: item.path,
                                title: item.name,
                                icon: item.icon || defaultIcon
                            };
                            // 处理子菜单
                            if (item.children && Array.isArray(item.children)) {
                                const validChildren = [];
                                item.children.forEach(child => {
                                    if (child.type === 2) {
                                        const childItem = {
                                            path: child.path,
                                            title: child.name,
                                            icon: child.icon || defaultIcon
                                        };
                                        validChildren.push(childItem);
                                    }
                                });
                                if (validChildren.length > 0) {
                                    menuItem.children = validChildren;
                                    result.push(menuItem);
                                }
                            }
                        } else if (item.type === 2) {
                            // 处理菜单类型
                            const menuItem = {
                                path: item.path,
                                title: item.name,
                                icon: item.icon || defaultIcon
                            };
                            // 处理二级菜单
                            if (item.children && Array.isArray(item.children)) {
                                const validChildren = [];
                                item.children.forEach(child => {
                                    if (child.type === 2) {
                                        const childItem = {
                                            path: child.path,
                                            title: child.name,
                                            icon: child.icon || defaultIcon
                                        };
                                        validChildren.push(childItem);
                                    }
                                });
                                if (validChildren.length > 0) {
                                    menuItem.children = validChildren;
                                }
                            }
                            result.push(menuItem);
                        }
                    });
                }

                traverse(data);
                console.log('登录时格式化后的菜单数据:', result);
                return result;
            },
            // 提交登陆信息
            submit() {
                this.$refs.loginForm.validate(async (valid, fields) => {
                    if (!valid) {
                        const fieldKeys = Object.keys(fields);
                        if (fieldKeys.length > 0) {
                            this.$message.error(fields[fieldKeys[0]][0].message);
                        } else {
                            this.$message.error('表单校验失败');
                        }
                        return;
                    }

                    if (!this.formLogin.account || !this.formLogin.password) {
                        this.$message.error('请填写所有字段');
                        return;
                    }

                    try {
                        // 登录请求
                        const loginRes = await this.$axios.post('/api-30216/auth/login', this.formLogin);
                        if (loginRes.code !== 200) {
                            throw new Error(loginRes.message || '登录失败');
                        }

                        // 保存 token
                        util.cookies.set('username', this.formLogin.account);
                        util.cookies.set('isAdmin', true);
                        util.cookies.set('token', loginRes.access_token);
                        util.cookies.set('refreshToken', loginRes.refresh_token);

                        // 获取菜单
                        const menuRes = await this.$axios.get('/api-30216/api/user/menus');
                        if (menuRes.code !== 200) {
                            throw new Error(menuRes.message || '获取菜单失败');
                        }

                        // ✅ 格式化菜单（只保留 type === 2）
                        const formattedMenu = this.formatMenuData(menuRes.data);

                        // 提交到 Vuex
                        this.$store.commit('d2adminMenuAsideSet', formattedMenu);

                        // ✅ 跳转到第一个菜单项的 path
                        const firstPath = formattedMenu.length > 0 ? formattedMenu[0].path : '/home';
                        this.$router.push({ path: firstPath });

                    } catch (error) {
                       // this.$message.error(error.message || '登录失败');
                    }
                });
            },
            changeLoginCode() {
                this.loginCodeUrl = "/service/sso/code/100/48/5/35/26?" + Math.random()
            }
        },

        
    }
</script>

<style lang="scss">
    @import './style.scss';
</style>
